import { render, staticRenderFns } from "./HSCodesTable.vue?vue&type=template&id=21d53ec2&scoped=true"
import script from "./HSCodesTable.vue?vue&type=script&lang=js"
export * from "./HSCodesTable.vue?vue&type=script&lang=js"
import style0 from "./HSCodesTable.vue?vue&type=style&index=0&id=21d53ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d53ec2",
  null
  
)

export default component.exports